export default class DuplicateDriveStart extends Error {
    constructor() {
        super("Drive already exists!");
    }
}
